<div class="vendorview-modal" id="vendor-template-addedit-modal-vendorview-modal">
  <app-vendor-template-addedit [data]="vendorTemplateData" id="vendor-template-addedit-modal-vendor-template-addedit"></app-vendor-template-addedit>
  <button (click)="closeVendorPopUpDialog()" mat-raised-button color="warn" class="pull-right close-button" id="vendor-template-addedit-modal-close-button">Close</button>
</div>
